import api from '@/redux/redux-api';
import { Action, ApiAction, AsyncResult } from '@/redux/index';
import { CustomProxiesData } from '@/types/custom-proxies-state';

const initialState: { customProxies: CustomProxiesData } = {
  customProxies: [],
};

// Actions
export const GET_CUSTOM_PROXIES: ApiAction = {
  type: 'connect/custom-proxies/getCustomProxies',
  endpoint: 'custom-proxies/',
};

export default function customProxiesReducer(state = initialState, action: Action) {
  switch (action.type) {
    case `${GET_CUSTOM_PROXIES.type}_SUCCESS`: {
      return {
        ...state,
        customProxies: action.data.data,
      };
    }
    default:
      return state;
  }
}

export const getCustomProxies = (): AsyncResult<CustomProxiesData> => (dispatch, getState) => api.get(GET_CUSTOM_PROXIES);
